import { ChangeDetectionStrategy, Component, HostBinding, Input } from "@angular/core";
import { TranslatedString } from 'models/translated-string';

export enum BadgeColor {
  Blue = 'blue',
  Purple = 'purple',
  Magenta = 'magenta',
  Yellow = 'yellow',
  Red = 'red',
  Green = 'green',
  Gray = 'gray',
  Light = 'light',
  TextOnly = 'text-only'
}

@Component({
  selector: 'cs-badge',
  templateUrl: 'cs-badge.html',
  host: { 'class': 'badge' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsBadgeComponent {
  @Input() icon: string;
  @Input() label: TranslatedString;
  @Input() info?: TranslatedString;
  @Input() color: string = BadgeColor.Blue;

  @HostBinding('class.blue')
  get isBlue() { return this.color === BadgeColor.Blue; }

  @HostBinding('class.purple')
  get isPurple() { return this.color === BadgeColor.Purple; }

  @HostBinding('class.magenta')
  get isMagenta() { return this.color === BadgeColor.Magenta; }

  @HostBinding('class.yellow')
  get isYellow() { return this.color === BadgeColor.Yellow; }

  @HostBinding('class.green')
  get isGreen() { return this.color === BadgeColor.Green; }

  @HostBinding('class.red')
  get isRed() { return this.color === BadgeColor.Red; }

  @HostBinding('class.gray')
  get isGray() { return this.color === BadgeColor.Gray; }

  @HostBinding('class.light')
  get isLight() { return this.color === BadgeColor.Light; }

  @HostBinding('class.text-only')
  get isTextOnly() { return this.color === BadgeColor.TextOnly; }
}
